import PropTypes from "prop-types"

import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import HighlightData from "../../../components/HighlightData"
import { withLoading } from "./WithLoading"

const Details = ({ header, data }) =>
  data ? (
    <Accordion sx={{ marginTop: "20px" }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>{header}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <HighlightData data={data} />
      </AccordionDetails>
    </Accordion>
  ) : null

Details.propTypes = {
  header: PropTypes.string,
  data: PropTypes.object
}

export const EntityDetails = withLoading(Details)
